import React from 'react';
import styled from '@emotion/styled';
import theme from '../../constants/theme';
const Wrapper = styled(({ useCustomUnderline, useButtonOutline, noUnderline, children, ...rest }) => React.createElement("a", Object.assign({}, rest), children)) `
  ${({ useCustomUnderline }) => !useCustomUnderline
    ? 'text-decoration: underline;'
    : `
      border-bottom: 2px solid ${theme.colors.leafyGreen};
      padding-bottom: 2px;
      opacity: .9;
      transition: ease-in .2s;
    `}
  ${({ useButtonOutline }) => useButtonOutline &&
    `
      border-radius: 34px;
      &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(112, 134, 128, 0.4)
      }
      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(112, 134, 128, 0.4)
      }
    `}
  ${({ noUnderline }) => (noUnderline ? 'text-decoration: none;' : ``)}
  font-weight: 600;
  color: ${theme.colors.leafyGreen};
  cursor: pointer;
  font-size: 14px;

  &:hover {
    ${({ useCustomUnderline }) => !useCustomUnderline ? `color: ${theme.colors.primary};` : 'opacity: 1;'}
  }
`;
export const Link = props => {
    const { children, ...anchorProps } = props;
    return React.createElement(Wrapper, Object.assign({}, anchorProps),
        children,
        " ");
};
//# sourceMappingURL=link.js.map